import { render, staticRenderFns } from "./QianchuanTaskLog.vue?vue&type=template&id=62c0ff23&scoped=true"
import script from "./QianchuanTaskLog.vue?vue&type=script&lang=js"
export * from "./QianchuanTaskLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0ff23",
  null
  
)

export default component.exports